import axios from 'axios'
import store from '../store'
import { clearAuth } from '../store/auth/slice'
import { checkAndUpdateToken } from '../actions/auth'

const api = axios.create({
  baseURL: process.env.REACT_APP_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

api.interceptors.request.use(async (config) => {
  if (store.getState().auth?.token) {
    await store.dispatch(checkAndUpdateToken())
  }
  const token = store.getState().auth?.token
  if (token) {
    config.headers.Authorization = `Basic ${btoa(`nnz:${token}`)}`
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      store.dispatch(clearAuth())
    }
    return Promise.reject(error)
  }
)

export default api
